import { jsxs as v, jsx as w } from "react/jsx-runtime";
import { c as R } from "./clsx-OuTLNxxd.js";
import H, { forwardRef as F, useRef as E, useImperativeHandle as K, useCallback as W, useEffect as A } from "react";
import "./button.types-BqgkEc5r.js";
import "./components/elements/button/iconButton/iconButton.js";
import "./components/layout/flex/flex.js";
import { I as j } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
import "./components/elements/tag/tag.js";
import "./components/elements/carousel/carousel.js";
import "./components/elements/inputs/input/input.js";
import "./components/elements/inputs/checkbox/checkbox.js";
import { R as G, I as q } from "./item-C-xn0lPK.js";
import "./components/elements/inputs/dateRangePicker/dateRangePicker.js";
import { usePhoneNumber as Y } from "./components/elements/inputs/phoneNumber/phoneNumber.hook.js";
import "./components/elements/toast/toast.context.js";
import "./map-DjiAXeob.js";
import { INPUT_STATUS as T, LOCALES as J, ICONS_STATUS as M } from "./components/elements/inputs/phoneNumber/phoneNumber.type.js";
const Z = "_title_ej2xw_37", Q = "_text_ej2xw_41", I = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: Z,
  text: Q,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function X({
  children: r,
  defaultValue: e,
  label: t,
  helperContent: i,
  errorMessage: s,
  disabled: n,
  onChange: o,
  onBlur: l,
  value: u,
  name: a
}) {
  const h = !!s, c = !!(t ?? i);
  return /* @__PURE__ */ v(
    G,
    {
      name: a,
      onValueChange: o,
      defaultValue: e,
      className: R(I["radio-group"], s && I["has-error"]),
      disabled: n,
      onBlur: l,
      value: u,
      children: [
        c && /* @__PURE__ */ v("div", { className: I["group-label"], children: [
          t && /* @__PURE__ */ w("label", { className: I.title, children: t }),
          i && /* @__PURE__ */ w("p", { className: I.text, children: i })
        ] }),
        r,
        h && /* @__PURE__ */ v("p", { className: I["error-message"], children: [
          /* @__PURE__ */ w(j, { name: "error-warning-fill", color: "error" }),
          s
        ] })
      ]
    }
  );
}
X.Item = q;
var tt = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], z = [];
for (const r of tt)
  z.push({
    name: "",
    // populated in the plugin
    iso2: r[0],
    dialCode: r[1],
    priority: r[2] || 0,
    areaCodes: r[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: r[4] || null
  });
var L = z, et = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, it = et, st = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, nt = st, ot = { ...it, ...nt }, O = ot, x = (r) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(r).matches, rt = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const r = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), e = x("(max-width: 500px)"), t = x("(max-height: 600px)"), i = x("(pointer: coarse)");
    return r || e || i && t;
  }
  return !1;
}, U = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: rt(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
};
function at(r) {
  r.useFullscreenPopup && (r.fixDropdownWidth = !1), r.onlyCountries.length === 1 && (r.initialCountry = r.onlyCountries[0]), r.separateDialCode && (r.nationalMode = !1), r.allowDropdown && !r.showFlags && !r.separateDialCode && (r.nationalMode = !1), r.useFullscreenPopup && !r.dropdownContainer && (r.dropdownContainer = document.body), r.i18n = { ...O, ...r.i18n };
}
var S = (r) => r.replace(/\D/g, ""), $ = (r = "") => r.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), m = (r, e, t) => {
  const i = document.createElement(r);
  return e && Object.entries(e).forEach(([s, n]) => i.setAttribute(s, n)), t && t.appendChild(i), i;
};
function lt(r) {
  const { onlyCountries: e, excludeCountries: t } = r;
  if (e.length) {
    const i = e.map((s) => s.toLowerCase());
    return L.filter((s) => i.includes(s.iso2));
  } else if (t.length) {
    const i = t.map((s) => s.toLowerCase());
    return L.filter((s) => !i.includes(s.iso2));
  }
  return L;
}
function ut(r, e) {
  for (const t of r) {
    const i = t.iso2.toLowerCase();
    e.i18n[i] && (t.name = e.i18n[i]);
  }
}
function dt(r, e) {
  const t = /* @__PURE__ */ new Set();
  let i = 0;
  const s = {}, n = (o, l, u) => {
    if (!o || !l)
      return;
    l.length > i && (i = l.length), s.hasOwnProperty(l) || (s[l] = []);
    const a = s[l];
    if (a.includes(o))
      return;
    const h = u !== void 0 ? u : a.length;
    a[h] = o;
  };
  for (const o of r)
    t.has(o.dialCode) || t.add(o.dialCode), n(o.iso2, o.dialCode, o.priority);
  (e.onlyCountries.length || e.excludeCountries.length) && t.forEach((o) => {
    s[o] = s[o].filter(Boolean);
  });
  for (const o of r)
    if (o.areaCodes) {
      const l = s[o.dialCode][0];
      for (const u of o.areaCodes) {
        for (let a = 1; a < u.length; a++) {
          const h = u.substring(0, a), c = o.dialCode + h;
          n(l, c), n(o.iso2, c);
        }
        n(o.iso2, o.dialCode + u);
      }
    }
  return { dialCodes: t, dialCodeMaxLen: i, dialCodeToIso2Map: s };
}
function ht(r, e) {
  e.countryOrder && (e.countryOrder = e.countryOrder.map((t) => t.toLowerCase())), r.sort((t, i) => {
    const { countryOrder: s } = e;
    if (s) {
      const n = s.indexOf(t.iso2), o = s.indexOf(i.iso2), l = n > -1, u = o > -1;
      if (l || u)
        return l && u ? n - o : l ? -1 : 1;
    }
    return t.name.localeCompare(i.name);
  });
}
function ct(r) {
  for (const e of r)
    e.normalisedName = $(e.name), e.initials = e.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((t) => t[0]).join("").toLowerCase(), e.dialCodePlus = `+${e.dialCode}`;
}
function pt(r, e, t, i) {
  let s = r;
  if (t && e) {
    e = `+${i.dialCode}`;
    const n = s[e.length] === " " || s[e.length] === "-" ? e.length + 1 : e.length;
    s = s.substring(n);
  }
  return s;
}
function mt(r, e, t, i, s) {
  const n = t ? t.formatNumberAsYouType(r, i.iso2) : r, { dialCode: o } = i;
  return s && e.charAt(0) !== "+" && n.includes(`+${o}`) ? (n.split(`+${o}`)[1] || "").trim() : n;
}
function ft(r, e, t, i) {
  if (t === 0 && !i)
    return 0;
  let s = 0;
  for (let n = 0; n < e.length; n++) {
    if (/[+0-9]/.test(e[n]) && s++, s === r && !i)
      return n + 1;
    if (i && s === r + 1)
      return n;
  }
  return e.length;
}
var Ct = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], B = (r) => {
  const e = S(r);
  if (e.charAt(0) === "1") {
    const t = e.substring(1, 4);
    return Ct.includes(t);
  }
  return !1;
};
for (const r of L)
  r.name = O[r.iso2];
var yt = 0, gt = new Set(L.map((r) => r.iso2)), k = (r) => gt.has(r), N = (r, ...e) => {
  const { instances: t } = d;
  Object.values(t).forEach((i) => i[r](...e));
}, _t = class P {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(e) {
    return Object.keys(e).filter((t) => !!e[t]).join(" ");
  }
  constructor(e, t = {}) {
    this.id = yt++, this.telInput = e, this.highlightedItem = null, this.options = Object.assign({}, U, t), this.hadInitialPlaceholder = !!e.getAttribute("placeholder");
  }
  _detectEnvironmentAndLayout() {
    this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const e = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !e : e, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft);
  }
  _createInitPromises() {
    const e = new Promise((i, s) => {
      this.resolveAutoCountryPromise = i, this.rejectAutoCountryPromise = s;
    }), t = new Promise((i, s) => {
      this.resolveUtilsScriptPromise = i, this.rejectUtilsScriptPromise = s;
    });
    this.promise = Promise.all([e, t]);
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    at(this.options), this._detectEnvironmentAndLayout(), this._createInitPromises(), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this.countries = lt(this.options);
    const e = dt(this.countries, this.options);
    this.dialCodes = e.dialCodes, this.dialCodeMaxLen = e.dialCodeMaxLen, this.dialCodeToIso2Map = e.dialCodeToIso2Map, ut(this.countries, this.options), ht(this.countries, this.options), this.countryByIso2 = new Map(this.countries.map((t) => [t.iso2, t])), ct(this.countries);
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this._prepareTelInput();
    const e = this._createWrapperAndInsert();
    this._maybeBuildCountryContainer(e), e.appendChild(this.telInput), this._maybeUpdateInputPaddingAndReveal(), this._maybeBuildHiddenInputs(e);
  }
  _prepareTelInput() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
  }
  _createWrapperAndInsert() {
    const {
      allowDropdown: e,
      showFlags: t,
      containerClass: i,
      useFullscreenPopup: s
    } = this.options, n = P._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": e,
      "iti--show-flags": t,
      "iti--inline-dropdown": !s,
      [i]: !!i
    }), o = m("div", { class: n });
    return this.telInput.parentNode?.insertBefore(o, this.telInput), o;
  }
  _maybeBuildCountryContainer(e) {
    const {
      allowDropdown: t,
      separateDialCode: i,
      showFlags: s
    } = this.options;
    if (t || s || i) {
      this.countryContainer = m(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        e
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", t ? (this.selectedCountry = m(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = m(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const n = m(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      this.selectedCountryInner = m(
        "div",
        { class: "iti__flag" },
        n
      ), t && (this.dropdownArrow = m(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        n
      )), i && (this.selectedDialCode = m(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), t && this._buildDropdownContent();
    }
  }
  _buildDropdownContent() {
    const {
      fixDropdownWidth: e,
      useFullscreenPopup: t,
      countrySearch: i,
      i18n: s,
      dropdownContainer: n,
      containerClass: o
    } = this.options, l = e ? "" : "iti--flexible-dropdown-width";
    if (this.dropdownContent = m("div", {
      id: `iti-${this.id}__dropdown-content`,
      class: `iti__dropdown-content iti__hide ${l}`,
      role: "dialog",
      "aria-modal": "true"
    }), i && this._buildSearchUI(), this.countryList = m(
      "ul",
      {
        class: "iti__country-list",
        id: `iti-${this.id}__country-listbox`,
        role: "listbox",
        "aria-label": s.countryListAriaLabel
      },
      this.dropdownContent
    ), this._appendListItems(), i && this._updateSearchResultsA11yText(), n) {
      const u = P._buildClassNames({
        iti: !0,
        "iti--container": !0,
        "iti--fullscreen-popup": t,
        "iti--inline-dropdown": !t,
        [o]: !!o
      });
      this.dropdown = m("div", { class: u }), this.dropdown.appendChild(this.dropdownContent);
    } else
      this.countryContainer.appendChild(this.dropdownContent);
  }
  _buildSearchUI() {
    const { i18n: e } = this.options, t = m(
      "div",
      { class: "iti__search-input-wrapper" },
      this.dropdownContent
    );
    this.searchIcon = m(
      "span",
      {
        class: "iti__search-icon",
        "aria-hidden": "true"
      },
      t
    ), this.searchIcon.innerHTML = `
      <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>`, this.searchInput = m(
      "input",
      {
        id: `iti-${this.id}__search-input`,
        // Chrome says inputs need either a name or an id
        type: "search",
        class: "iti__search-input",
        placeholder: e.searchPlaceholder,
        // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
        role: "combobox",
        "aria-expanded": "true",
        "aria-label": e.searchPlaceholder,
        "aria-controls": `iti-${this.id}__country-listbox`,
        "aria-autocomplete": "list",
        autocomplete: "off"
      },
      t
    ), this.searchClearButton = m(
      "button",
      {
        type: "button",
        class: "iti__search-clear iti__hide",
        "aria-label": e.clearSearchAriaLabel,
        tabindex: "-1"
      },
      t
    );
    const i = `iti-${this.id}-clear-mask`;
    this.searchClearButton.innerHTML = `
      <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <mask id="${i}" maskUnits="userSpaceOnUse">
          <rect width="16" height="16" fill="white" />
          <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
        </mask>
        <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${i})" />
      </svg>`, this.searchResultsA11yText = m(
      "span",
      { class: "iti__a11y-text" },
      this.dropdownContent
    ), this.searchNoResults = m(
      "div",
      {
        class: "iti__no-results iti__hide",
        "aria-hidden": "true"
        // all a11y messaging happens in this.searchResultsA11yText
      },
      this.dropdownContent
    ), this.searchNoResults.textContent = e.zeroSearchResults;
  }
  _maybeUpdateInputPaddingAndReveal() {
    this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide"));
  }
  _maybeBuildHiddenInputs(e) {
    const { hiddenInput: t } = this.options;
    if (t) {
      const i = this.telInput.getAttribute("name") || "", s = t(i);
      if (s.phone) {
        const n = this.telInput.form?.querySelector(`input[name="${s.phone}"]`);
        n ? this.hiddenInput = n : (this.hiddenInput = m("input", {
          type: "hidden",
          name: s.phone
        }), e.appendChild(this.hiddenInput));
      }
      if (s.country) {
        const n = this.telInput.form?.querySelector(`input[name="${s.country}"]`);
        n ? this.hiddenInputCountry = n : (this.hiddenInputCountry = m("input", {
          type: "hidden",
          name: s.country
        }), e.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let e = 0; e < this.countries.length; e++) {
      const t = this.countries[e], i = e === 0 ? "iti__highlight" : "", s = m(
        "li",
        {
          id: `iti-${this.id}__item-${t.iso2}`,
          class: `iti__country ${i}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": t.dialCode,
          "data-country-code": t.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      t.nodeById[this.id] = s;
      let n = "";
      this.options.showFlags && (n += `<div class='iti__flag iti__${t.iso2}'></div>`), n += `<span class='iti__country-name'>${t.name}</span>`, n += `<span class='iti__dial-code' dir='ltr'>+${t.dialCode}</span>`, s.insertAdjacentHTML("beforeend", n);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(e = !1) {
    const t = this.telInput.getAttribute("value"), i = this.telInput.value, n = t && t.charAt(0) === "+" && (!i || i.charAt(0) !== "+") ? t : i, o = this._getDialCode(n), l = B(n), { initialCountry: u, geoIpLookup: a } = this.options, h = u === "auto" && a;
    if (o && !l)
      this._updateCountryFromNumber(n);
    else if (!h || e) {
      const c = u ? u.toLowerCase() : "";
      k(c) ? this._setCountry(c) : o && l ? this._setCountry("us") : this._setCountry("");
    }
    n && this._updateValFromNumber(n);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (t) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : t.preventDefault();
    };
    const e = this.telInput.closest("label");
    e && e.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (t) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(t.key) && (t.preventDefault(), t.stopPropagation(), this._openDropdown()), t.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: e, initialCountry: t, geoIpLookup: i } = this.options;
    e && !d.utils ? (this._doAttachUtils = () => {
      d.attachUtils(e)?.catch(() => {
      });
    }, d.documentReady() ? this._doAttachUtils() : (this._handlePageLoad = () => {
      this._doAttachUtils();
    }, window.addEventListener("load", this._handlePageLoad))) : this.resolveUtilsScriptPromise(), t === "auto" && i && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    d.autoCountry ? this.handleAutoCountry() : d.startedLoadingAutoCountry || (d.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (e = "") => {
        const t = e.toLowerCase();
        k(t) ? (d.autoCountry = t, setTimeout(() => N("handleAutoCountry"))) : (this._setInitialState(!0), N("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), N("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    this._bindInputListener(), this._maybeBindKeydownListener(), this._maybeBindPasteListener();
  }
  _bindInputListener() {
    const { strictMode: e, formatAsYouType: t, separateDialCode: i, allowDropdown: s, countrySearch: n } = this.options;
    let o = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (o = !0), this._handleInputEvent = (l) => {
      if (this.isAndroid && l?.data === "+" && i && s && n) {
        const c = this.telInput.selectionStart || 0, p = this.telInput.value.substring(0, c - 1), f = this.telInput.value.substring(c);
        this.telInput.value = p + f, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const u = l?.data && /[^+0-9]/.test(l.data), a = l?.inputType === "insertFromPaste" && this.telInput.value;
      u || a && !e ? o = !0 : /[^+0-9]/.test(this.telInput.value) || (o = !1);
      const h = l?.detail && l.detail.isSetNumber;
      if (t && !o && !h) {
        const c = this.telInput.selectionStart || 0, f = this.telInput.value.substring(0, c).replace(/[^+0-9]/g, "").length, y = l?.inputType === "deleteContentForward", C = this._getFullNumber(), g = mt(
          C,
          this.telInput.value,
          d.utils,
          this.selectedCountryData,
          this.options.separateDialCode
        ), _ = ft(f, g, c, y);
        this.telInput.value = g, this.telInput.setSelectionRange(_, _);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent);
  }
  _maybeBindKeydownListener() {
    const { strictMode: e, separateDialCode: t, allowDropdown: i, countrySearch: s } = this.options;
    (e || t) && (this._handleKeydownEvent = (n) => {
      if (n.key && n.key.length === 1 && !n.altKey && !n.ctrlKey && !n.metaKey) {
        if (t && i && s && n.key === "+") {
          n.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (e) {
          const o = this.telInput.value, u = !(o.charAt(0) === "+") && this.telInput.selectionStart === 0 && n.key === "+", a = /^[0-9]$/.test(n.key), h = t ? a : u || a, c = o.slice(0, this.telInput.selectionStart) + n.key + o.slice(this.telInput.selectionEnd), p = this._getFullNumber(c), f = d.utils.getCoreNumber(p, this.selectedCountryData.iso2), y = this.maxCoreNumberLength && f.length > this.maxCoreNumberLength, g = this._getNewCountryFromNumber(p) !== null;
          (!h || y && !g && !u) && n.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  _maybeBindPasteListener() {
    this.options.strictMode && (this._handlePasteEvent = (e) => {
      e.preventDefault();
      const t = this.telInput, i = t.selectionStart, s = t.selectionEnd, n = t.value.slice(0, i), o = t.value.slice(s), l = this.selectedCountryData.iso2, u = e.clipboardData.getData("text"), a = i === 0 && s > 0, h = !t.value.startsWith("+") || a, c = u.replace(/[^0-9+]/g, ""), p = c.startsWith("+"), f = c.replace(/\+/g, ""), y = p && h ? `+${f}` : f;
      let C = n + y + o, g = d.utils.getCoreNumber(C, l);
      for (; g.length === 0 && C.length > 0; )
        C = C.slice(0, -1), g = d.utils.getCoreNumber(C, l);
      if (!g)
        return;
      if (this.maxCoreNumberLength && g.length > this.maxCoreNumberLength)
        if (t.selectionEnd === t.value.length) {
          const D = g.length - this.maxCoreNumberLength;
          C = C.slice(0, C.length - D);
        } else
          return;
      t.value = C;
      const _ = i + y.length;
      t.setSelectionRange(_, _), t.dispatchEvent(new InputEvent("input", { bubbles: !0 }));
    }, this.telInput.addEventListener("paste", this._handlePasteEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(e) {
    const t = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return t && e.length > t ? e.substring(0, t) : e;
  }
  //* Trigger a custom event on the input.
  _trigger(e, t = {}) {
    const i = new CustomEvent(e, {
      bubbles: !0,
      cancelable: !0,
      detail: t
    });
    this.telInput.dispatchEvent(i);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: e, countrySearch: t } = this.options;
    if (e && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), t) {
      const i = this.countryList.firstElementChild;
      i && (this._highlightListItem(i, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const e = this.telInput.getBoundingClientRect(), t = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${e.top + t}px`, this.dropdown.style.left = `${e.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (i) => {
      const s = i.target?.closest(".iti__country");
      s && this._highlightListItem(s, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (i) => {
      const s = i.target?.closest(".iti__country");
      s && this._selectListItem(s);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (i) => {
      !!i.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let e = "", t = null;
    if (this._handleKeydownOnDropdown = (i) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(i.key) && (i.preventDefault(), i.stopPropagation(), i.key === "ArrowUp" || i.key === "ArrowDown" ? this._handleUpDownKey(i.key) : i.key === "Enter" ? this._handleEnterKey() : i.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(i.key) && (i.stopPropagation(), t && clearTimeout(t), e += i.key.toLowerCase(), this._searchForCountry(e), t = setTimeout(() => {
        e = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const i = () => {
        const n = this.searchInput.value.trim();
        this._filterCountries(n), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let s = null;
      this._handleSearchChange = () => {
        s && clearTimeout(s), s = setTimeout(() => {
          i(), s = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), i();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(e) {
    for (const t of this.countries)
      if (t.name.substring(0, e.length).toLowerCase() === e) {
        const s = t.nodeById[this.id];
        this._highlightListItem(s, !1), this._scrollTo(s);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(e) {
    this.countryList.innerHTML = "";
    let t;
    e === "" ? t = this.countries : t = this._getMatchedCountries(e);
    let i = !0;
    for (const s of t) {
      const n = s.nodeById[this.id];
      n && (this.countryList.appendChild(n), i && (this._highlightListItem(n, !1), i = !1));
    }
    i ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  _getMatchedCountries(e) {
    const t = $(e), i = [], s = [], n = [], o = [], l = [], u = [];
    for (const a of this.countries)
      a.iso2 === t ? i.push(a) : a.normalisedName.startsWith(t) ? s.push(a) : a.normalisedName.includes(t) ? n.push(a) : t === a.dialCode || t === a.dialCodePlus ? o.push(a) : a.dialCodePlus.includes(t) ? l.push(a) : a.initials.includes(t) && u.push(a);
    return [
      ...i.sort((a, h) => a.priority - h.priority),
      ...s.sort((a, h) => a.priority - h.priority),
      ...n.sort((a, h) => a.priority - h.priority),
      ...o.sort((a, h) => a.priority - h.priority),
      ...l.sort((a, h) => a.priority - h.priority),
      ...u.sort((a, h) => a.priority - h.priority)
    ];
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: e } = this.options, t = this.countryList.childElementCount;
    let i;
    t === 0 ? i = e.zeroSearchResults : e.searchResultsText ? i = e.searchResultsText(t) : t === 1 ? i = e.oneSearchResult : i = e.multipleSearchResults.replace("${count}", t.toString()), this.searchResultsA11yText.textContent = i;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(e) {
    let t = e === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !t && this.countryList.childElementCount > 1 && (t = e === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), t && (this._scrollTo(t), this._highlightListItem(t, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(e) {
    let t = e;
    if (this.options.formatOnDisplay && d.utils && this.selectedCountryData) {
      const i = this.options.nationalMode || t.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: s, INTERNATIONAL: n } = d.utils.numberFormat, o = i ? s : n;
      t = d.utils.formatNumber(
        t,
        this.selectedCountryData.iso2,
        o
      );
    }
    t = this._beforeSetNumber(t), this.telInput.value = t;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(e) {
    const t = this._getNewCountryFromNumber(e);
    return t !== null ? this._setCountry(t) : !1;
  }
  _ensureHasDialCode(e) {
    const { dialCode: t, nationalPrefix: i } = this.selectedCountryData;
    if (e.charAt(0) === "+" || !t)
      return e;
    const o = i && e.charAt(0) === i && !this.options.separateDialCode ? e.substring(1) : e;
    return `+${t}${o}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(e) {
    const t = e.indexOf("+");
    let i = t ? e.substring(t) : e;
    const s = this.selectedCountryData.iso2, n = this.selectedCountryData.dialCode;
    i = this._ensureHasDialCode(i);
    const o = this._getDialCode(i, !0), l = S(i);
    if (o) {
      const u = S(o), a = this.dialCodeToIso2Map[u];
      if (a.length === 1)
        return a[0] === s ? null : a[0];
      if (!s && this.defaultCountry && a.includes(this.defaultCountry))
        return this.defaultCountry;
      if (n === "1" && B(l))
        return null;
      const c = this.selectedCountryData.areaCodes && l.length > u.length;
      if (!(s && a.includes(s) && !c))
        return a[0];
    } else {
      if (i.charAt(0) === "+" && l.length)
        return "";
      if ((!i || i === "+") && !s)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(e, t) {
    const i = this.highlightedItem;
    if (i && (i.classList.remove("iti__highlight"), i.setAttribute("aria-selected", "false")), this.highlightedItem = e, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const s = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", s);
    }
    t && this.highlightedItem.focus();
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(e) {
    const { separateDialCode: t, showFlags: i, i18n: s } = this.options, n = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = e ? this.countryByIso2.get(e) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const o = e && i ? `iti__flag iti__${e}` : "iti__flag iti__globe";
      let l, u;
      if (e) {
        const { name: a, dialCode: h } = this.selectedCountryData;
        u = a, l = s.selectedCountryAriaLabel.replace("${countryName}", a).replace("${dialCode}", `+${h}`);
      } else
        u = s.noCountrySelected, l = s.noCountrySelected;
      this.selectedCountryInner.className = o, this.selectedCountry.setAttribute("title", u), this.selectedCountry.setAttribute("aria-label", l);
    }
    if (t) {
      const o = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = o, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), n !== e;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const e = this.options.separateDialCode ? 78 : 42, i = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || e) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${i}px` : this.telInput.style.paddingRight = `${i}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: e, placeholderNumberType: t, validationNumberTypes: i } = this.options, { iso2: s } = this.selectedCountryData;
    if (e && d.utils)
      if (s) {
        const n = d.utils.numberType[t];
        let o = d.utils.getExampleNumber(
          s,
          !1,
          n,
          !0
        ), l = o;
        for (; d.utils.isPossibleNumber(o, s, i); )
          l = o, o += "0";
        const u = d.utils.getCoreNumber(l, s);
        this.maxCoreNumberLength = u.length, s === "by" && (this.maxCoreNumberLength = u.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let e;
      try {
        e = window.top.document.body;
      } catch {
        e = document.body;
      }
      const t = this.telInput.parentNode.cloneNode(!1);
      t.style.visibility = "hidden", e.appendChild(t);
      const i = this.countryContainer.cloneNode();
      t.appendChild(i);
      const s = this.selectedCountry.cloneNode(!0);
      i.appendChild(s);
      const n = s.offsetWidth;
      return e.removeChild(t), n;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: e,
      placeholderNumberType: t,
      nationalMode: i,
      customPlaceholder: s
    } = this.options, n = e === "aggressive" || !this.hadInitialPlaceholder && e === "polite";
    if (d.utils && n) {
      const o = d.utils.numberType[t];
      let l = this.selectedCountryData.iso2 ? d.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        i,
        o
      ) : "";
      l = this._beforeSetNumber(l), typeof s == "function" && (l = s(l, this.selectedCountryData)), this.telInput.setAttribute("placeholder", l);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(e) {
    const t = e.getAttribute("data-country-code"), i = this._setCountry(t);
    this._closeDropdown();
    const s = e.getAttribute("data-dial-code");
    this._updateDialCode(s), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), i && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(e) {
    const t = this.countryList, i = document.documentElement.scrollTop, s = t.offsetHeight, n = t.getBoundingClientRect().top + i, o = n + s, l = e.offsetHeight, u = e.getBoundingClientRect().top + i, a = u + l, h = u - n + t.scrollTop;
    if (u < n)
      t.scrollTop = h;
    else if (a > o) {
      const c = s - l;
      t.scrollTop = h - c;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(e) {
    const t = this.telInput.value, i = `+${e}`;
    let s;
    if (t.charAt(0) === "+") {
      const n = this._getDialCode(t);
      n ? s = t.replace(n, i) : s = i, this.telInput.value = s;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(e, t) {
    let i = "";
    if (e.charAt(0) === "+") {
      let s = "";
      for (let n = 0; n < e.length; n++) {
        const o = e.charAt(n);
        if (/[0-9]/.test(o)) {
          if (s += o, t)
            this.dialCodeToIso2Map[s] && (i = e.substring(0, n + 1));
          else if (this.dialCodes.has(s)) {
            i = e.substring(0, n + 1);
            break;
          }
          if (s.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return i;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(e) {
    const t = e || this.telInput.value.trim(), { dialCode: i } = this.selectedCountryData;
    let s;
    const n = S(t);
    return this.options.separateDialCode && t.charAt(0) !== "+" && i && n ? s = `+${i}` : s = "", s + t;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(e) {
    const t = this._getDialCode(e), i = pt(
      e,
      t,
      this.options.separateDialCode,
      this.selectedCountryData
    );
    return this._cap(i);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && d.autoCountry && (this.defaultCountry = d.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    d.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: e, separateDialCode: t } = this.options;
    if (e) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const n = this.telInput.closest("label");
      n && n.removeEventListener("click", this._handleLabelClick);
    }
    const { form: i } = this.telInput;
    this._handleHiddenInputSubmit && i && i.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this._handlePasteEvent && this.telInput.removeEventListener("paste", this._handlePasteEvent), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this.telInput.removeAttribute("data-intl-tel-input-id"), t && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const s = this.telInput.parentNode;
    s?.parentNode?.insertBefore(this.telInput, s), s?.parentNode?.removeChild(s), delete d.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return d.utils ? d.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(e) {
    if (d.utils) {
      const { iso2: t } = this.selectedCountryData;
      return d.utils.formatNumber(
        this._getFullNumber(),
        t,
        e
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return d.utils ? d.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (d.utils) {
      const { iso2: e } = this.selectedCountryData;
      return d.utils.getValidationError(this._getFullNumber(), e);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(e) {
    return d.utils ? d.utils.isPossibleNumber(e, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(e) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const t = (o) => e ? this._utilsIsValidNumber(o) : this._utilsIsPossibleNumber(o), i = this._getFullNumber(), s = i.search(new RegExp("\\p{L}", "u"));
    if (s > -1 && !this.options.allowPhonewords) {
      const o = i.substring(0, s), l = t(o), u = t(i);
      return l && u;
    }
    return t(i);
  }
  _utilsIsValidNumber(e) {
    return d.utils ? d.utils.isValidNumber(e, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(e) {
    const t = e?.toLowerCase();
    if (!k(t))
      throw new Error(`Invalid country code: '${t}'`);
    const i = this.selectedCountryData.iso2;
    (e && t !== i || !e && i) && (this._setCountry(t), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(e) {
    const t = this._updateCountryFromNumber(e);
    this._updateValFromNumber(e), t && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(e) {
    this.options.placeholderNumberType = e, this._updatePlaceholder();
  }
  setDisabled(e) {
    this.telInput.disabled = e, e ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, bt = (r) => {
  if (!d.utils && !d.startedLoadingUtilsScript) {
    let e;
    if (typeof r == "function")
      try {
        e = Promise.resolve(r());
      } catch (t) {
        return Promise.reject(t);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof r}`));
    return d.startedLoadingUtilsScript = !0, e.then((t) => {
      const i = t?.default;
      if (!i || typeof i != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return d.utils = i, N("handleUtils"), !0;
    }).catch((t) => {
      throw N("rejectUtilsScriptPromise", t), t;
    });
  }
  return null;
}, d = Object.assign(
  (r, e) => {
    const t = new _t(r, e);
    return t._init(), r.setAttribute("data-intl-tel-input-id", t.id.toString()), d.instances[t.id] = t, r.iti = t, t;
  },
  {
    defaults: U,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => L,
    //* A getter for the plugin instance.
    getInstance: (r) => {
      const e = r.getAttribute("data-intl-tel-input-id");
      return e ? d.instances[e] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: bt,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.10"
  }
), wt = d, It = F(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: i = () => {
  },
  onChangeValidity: s = () => {
  },
  onChangeErrorCode: n = () => {
  },
  usePreciseValidation: o = !1,
  initOptions: l = {},
  inputProps: u = {},
  disabled: a = void 0
}, h) {
  const c = E(null), p = E(null);
  K(h, () => ({
    getInstance: () => p.current,
    getInput: () => c.current
  }));
  const f = W(() => {
    const y = p.current?.getNumber() || "", C = p.current?.getSelectedCountryData().iso2 || "";
    if (t(y), i(C), p.current)
      if (o ? p.current.isValidNumberPrecise() : p.current.isValidNumber())
        s(!0), n(null);
      else {
        const _ = p.current.getValidationError();
        s(!1), n(_);
      }
  }, [i, n, t, s, o]);
  return A(() => (c.current && (p.current = wt(c.current, l)), () => {
    p.current?.destroy();
  }), []), A(() => {
    const y = c.current;
    return y && (y.addEventListener("countrychange", f), p.current.promise.then(f)), () => {
      y && y.removeEventListener("countrychange", f);
    };
  }, [f]), A(() => {
    p.current && a !== void 0 && p.current.setDisabled(a);
  }, [a]), /* @__PURE__ */ H.createElement(
    "input",
    {
      type: "tel",
      ref: c,
      onInput: f,
      defaultValue: e,
      ...u
    }
  );
}), vt = It;
const b = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
}, $t = F(
  ({
    label: r,
    helperText: e,
    initialPhoneNumber: t,
    onChangePhoneNumber: i,
    initialCountry: s,
    onChangeCountry: n,
    locale: o = "en",
    message: l,
    status: u,
    disabled: a,
    isFullWidth: h,
    inputProps: c,
    setErrorCode: p,
    setIsValidPhoneNumber: f
  }, y) => {
    const { phoneNumber: C, country: g, handlePhoneNumberChange: _, handleCountryChange: D } = Y({
      initialPhoneNumber: t,
      initialCountry: s,
      onChangePhoneNumber: i,
      onChangeCountry: n
    }), V = R(
      b["phone-number"],
      a && b["is-disabled"],
      u && b[T[u]],
      h && b["is-full-width"]
    );
    return /* @__PURE__ */ v("div", { className: V, children: [
      /* @__PURE__ */ v("div", { className: b["group-label"], children: [
        r && /* @__PURE__ */ w("label", { children: r }),
        e && /* @__PURE__ */ w("div", { className: b["helper-text"], children: e })
      ] }),
      /* @__PURE__ */ w(
        vt,
        {
          initialValue: C,
          onChangeErrorCode: p,
          onChangeValidity: f,
          onChangeCountry: D,
          onChangeNumber: _,
          inputProps: {
            disabled: a,
            "aria-label": c?.["aria-label"] || r,
            ...c
          },
          ref: y,
          initOptions: {
            strictMode: !0,
            initialCountry: g,
            i18n: J[o],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CJDvlpOH.js")
          }
        }
      ),
      l && u && !a && /* @__PURE__ */ v("div", { className: b["container-icon"], children: [
        /* @__PURE__ */ w(j, { name: M[u].name, size: "medium", color: M[u].color }),
        /* @__PURE__ */ w("span", { className: b[T[u]], children: l })
      ] })
    ] });
  }
);
export {
  $t as P,
  X as R
};
